import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import MeetJoanne from "@/components/site/MeetJoanne";
import Ascend from "@/components/site/Ascend";
import ChoosePath from "@/components/site/ChoosePath";
import Labs from "@/components/site/Labs";
import Connect from "@/components/site/Connect";
import Journal from "@/components/site/Journal";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <MeetJoanne />
        <ChoosePath />
        <Labs />
        <Ascend />
        <Connect />
      </main>
      <Footer />
    </div>
  );
}
